import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AlertTypes } from '../models/alert.model';
import { Alert } from '../interfaces/alert';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private message = new BehaviorSubject<Alert>({ message: '', type: AlertTypes.Success });
  alert = this.message.asObservable();

  constructor() { }

  setMessage(message: string, type = AlertTypes.Success) {
    this.message.next({ message, type });
  }
}
